module.exports = __webpack_public_path__ + "img/banner.6495441a.png";